import * as R from 'ramda'

// getCookies :: () -> {str: str}
export const getCookies = R.pipe(
  R.always(global.document),
  R.propOr('', 'cookie'),
  R.split(/; */),
  R.map(R.split('=')),
  R.fromPairs,
)

// getCookie :: (str, str?) -> str
export const getCookie = (key, fallback) => {
  const cookies = getCookies()
  if (cookies[key]) return cookies[key]
  if (fallback) return fallback
  else throw new Error(`missing cookie: ${key}`)
}
